
























import { Component, Prop, Watch } from 'vue-property-decorator';
import DateLimitsMixin from "@mixins/DateLimitsMixin";
import DateSwitcher from "./DateSwitcher.vue"
import TagList from "@share/common/tag-list-dates/TagListDates.vue";
import { DateTime } from 'luxon';
import { SelectableTag } from '@api/models/SelectableTag';
import { Tag } from '@api/models/Tag';

@Component({
    components: { DateSwitcher, TagList }
})
export default class AgendaFilterDateSwitcher extends DateLimitsMixin {
    @Prop({default: () => DateTime.local()}) value: DateTime | null;
    @Prop({ default: true }) needSetDefaultDate: boolean;
    @Prop({ default: ""} ) forcedPickerSide: "left" | "right" | "";
    @Prop({ default: ""}) labelSide: "left" | "right" | "";
    @Prop({ default: true }) useArrows: boolean;
    @Prop({ required: true }) type: "past" | "upcoming";

    selectDate(tag: SelectableTag) {
        if(DateTime.fromISO(tag.tag.id).startOf("day").toISO() === this.date?.startOf("day")?.toISO()) {
            this.date = null;
        }
        else {
            this.date = DateTime.fromISO(tag.tag.id);
        }
    }

    clearDate() {
        this.date = null;
    }

    getDateTag(now: DateTime, dayOffset: number) {
        return this.type === "past" ? now.minus({ days: dayOffset }) : now.plus({ days: dayOffset });
    }

    @Watch('date')
    watchDateHandeler() {
        this.$nextTick(() => {
            (this.$refs.tags as TagList | undefined)?.updateList();
        })
    }

    get tags(): SelectableTag[] {
        return this.date ?
            [{
                tag: new Tag({ id: this.date.toISO() || "", title: this.date.toFormat("d MMMM") }),
                isSelected: this.date?.startOf("day").toISO().split('.')[0] === this.date?.startOf("day").toISO().split('.')[0]
            }] :
            []
    }

    get date() {
        return this.value
    }

    set date(date: DateTime | null) {
        this.$emit('input', date);
    }

    get lang(): string {
        return this.$store.state.session.language || 'en'
    }
}
